import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  BusinessButton,
  TabButtonFlatButton,
} from "../../../common-components";
import {
  HeaderThirdPartyRequest,
  ThirdPartyRequestListItem,
  ViewBusiness,
} from "./components";

const ThirdPartyDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
}) => {
  const [open, setOpen] = useState(false);
  const [tableDisplay, setTableDisplay] = useState("approved");
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);

  const [thirdPartyBusinesses, setThirdPartyBusinesses] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const [approvedBusinessList, setApprovedBusinessList] = useState(null);

  const [requestBusinessList, setRequestBusinessList] = useState(null);

  const [declinedBusinessList, setDeclinedBusinessList] = useState(null);

  const GetApprovedBusinessList = async () => {
    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/thirdParty/getApprovedBusiness"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setApprovedBusinessList(resData.approvedBusiness);
      });
  };
  const GetRequestsBusinessList = async () => {
    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/thirdParty/getRequestBusiness"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setRequestBusinessList(resData.pendingBusiness);
        setDeclinedBusinessList(resData.declinedBusiness);
      });
  };
  useEffect(() => {
    GetApprovedBusinessList();
    GetRequestsBusinessList();
  }, [refresh]);

  useEffect(() => {
    setOpen(true);
    setSelectedBusiness(null);
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
        backgroundColor: open ? colors.secondaryGrey : colors.primaryBlue,
        flexDirection: "column",
      }}
    >
      {/* tabs */}
      <div
        style={{
          display: "flex",
          height: 40,
          backgroundColor: colors.greenDark,
          top: -40,
          position: "absolute",
        }}
      >
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"APPROVED"}
            backgroundColor={
              tableDisplay === "approved"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "approved" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("approved")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"REQUESTS"}
            backgroundColor={
              tableDisplay === "requests"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "requests" ? colors.greenDark : colors.white
            }
            onClick={() => {
              setTableDisplay("requests");
            }}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"DECLINED"}
            backgroundColor={
              tableDisplay === "declined"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "declined" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("declined")}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 5,
        }}
      ></div>
      <HeaderThirdPartyRequest />
      {tableDisplay === "approved" ? (
        <div
          style={{
            flex: 1,
            //   marginTop: 10,
            width: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
            alignItems: "center",
          }}
        >
          {approvedBusinessList
            ? approvedBusinessList.map((business, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <ThirdPartyRequestListItem
                      businessName={business.businessName}
                      service={business.service}
                      email={business.email}
                      cellNumber={business.cellNumber}
                      status={business.status}
                      onRequestClick={() => setSelectedBusiness(business)}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}

      {tableDisplay === "requests" ? (
        <div
          style={{
            flex: 1,
            //   marginTop: 10,
            width: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
            alignItems: "center",
            //   borderStyle: "solid",
            //   backgroundColor: colors.white,
          }}
        >
          {requestBusinessList
            ? requestBusinessList.map((business, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <ThirdPartyRequestListItem
                      businessName={business.businessName}
                      service={business.service}
                      email={business.email}
                      cellNumber={business.cellNumber}
                      status={business.status}
                      onRequestClick={() => setSelectedBusiness(business)}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}

      {tableDisplay === "declined" ? (
        <div
          style={{
            flex: 1,

            width: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
            alignItems: "center",
          }}
        >
          {requestBusinessList
            ? declinedBusinessList.map((business, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <ThirdPartyRequestListItem
                      businessName={business.businessName}
                      service={business.service}
                      email={business.email}
                      cellNumber={business.cellNumber}
                      status={business.status}
                      onRequestClick={() => setSelectedBusiness(business)}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      <ViewBusiness
        display={selectedBusiness}
        setSelectedBusiness={setSelectedBusiness}
        tableDisplay={tableDisplay}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
};

export default ThirdPartyDisplay;
